import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridLibAngularComponentModule } from '@gen-nexus-registry/grid-lib-angular/dist/grid-lib-angular-component';
import { SicAniaComponent } from './sic-ania.component';
import { SicAniaRoutingModule } from './sic-ania-routing.module';
import { DashboardModule } from './dashboard/dashboard.module';

@NgModule({
  declarations: [SicAniaComponent],
  imports: [
    SicAniaRoutingModule,
    CommonModule,
    GridLibAngularComponentModule,
    DashboardModule
  ]
})
export class SicAniaModule {}
